export default __webpack_public_path__ + "static/media/oi_4.14960a85.mp3";